export default __webpack_public_path__ + "static/ak-cached/24h/media/viewing-screen-mobile.f19e6b04.png";